var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C1.22922 1.0385 1.32131 1.47513 1.50716 1.6C1.64584 1.69318 1.77486 1.91039 1.90651 2.03704C2.02205 2.14819 2.17955 2.3056 2.27892 2.43704C2.3945 2.58993 2.55287 2.61539 2.67582 2.74815C2.87991 2.96852 3.10854 3.13368 3.31283 3.34815C3.5234 3.5692 3.74794 3.75706 3.95474 3.98519C4.10882 4.15516 4.30043 4.23059 4.43984 4.42963C4.80459 4.95039 5.34218 5.27666 5.73836 5.76667C5.8424 5.89535 5.92531 6.11655 6.04951 6.2C6.11318 6.24277 6.30119 6.47786 6.33616 6.57037C6.41736 6.78518 7.04281 7.4294 6.99767 7.6C6.94669 7.79268 6.75732 8.04815 6.64487 8.14815C6.25854 8.49168 5.94874 9.04795 5.57666 9.42963C4.90688 10.1167 4.2909 10.9029 3.57988 11.5C3.13861 11.8706 2.62305 12.407 2.25442 12.9333C2.1142 13.1335 1.94834 13.2846 1.80361 13.4815C1.67641 13.6545 1.51675 13.9174 1.3528 14",
    stroke: "#C1C1C7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.785d4050d30865a20d8a7cf56531c3d1.svg";
export { ForwardRef as ReactComponent };